const CREATE_ACCOUNT_FORM = 'CREATE_ACCOUNT_FORM';

export { 
  CREATE_ACCOUNT_FORM,
}